// Import and export EVERY saga here
import { all } from 'redux-saga/effects';
import { unitsSagas } from './units';
import { userSagas } from './user';
import { theoryLessonsSagas } from './theoryLessons';
import { drivingLessonsSagas } from './drivingLessons';
import { workItemSagas } from './workItem';
import { generalDataSagas } from './general';
import formActionSaga from 'redux-form-saga';
import {applicantsLessonsSagas} from "./applicantsLessonStatus";
import {lessonEditSagas} from "./lessonsEdit";
import {lessonsReportSagas} from "./lessonsReport";
import { dataImportSagas } from "./dataImport";

export default function* rootSaga() {
  yield all([
    unitsSagas(),
    userSagas(),
    theoryLessonsSagas(),
    drivingLessonsSagas(),
    workItemSagas(),
    generalDataSagas(),
    formActionSaga(),
    applicantsLessonsSagas(),
    lessonEditSagas(),
    lessonsReportSagas(),
    dataImportSagas(),
  ]);
}


// WEBPACK FOOTER //
// ./src/ducks/rootSaga.js